import React from "react";
import { BRAND_LOGO_PATH } from "../lib/brand";

export function LogoMark({ size = 40 }) {
  return (
    <img
      src={BRAND_LOGO_PATH}
      alt=""
      aria-hidden="true"
      height={size}
      style={{ display: "block", height: size, width: "auto" }}
    />
  );
}

export function Logo({ size = 38, dark = false }) {
  return (
    <span className="site-logo inline-flex items-center gap-3" data-testid="site-logo" role="img" aria-label="S-UK Driving School">
      <LogoMark size={size} />
      <span className={`site-logo__wordmark font-heading font-extrabold tracking-[0.14em] uppercase ${dark ? "text-neutral-300" : "text-neutral-600"}`} style={{ fontSize: size * 0.34 }}>
        Driving School
      </span>
    </span>
  );
}
